import styled from '@pinecast/styles';
import * as React from 'react';

const Wrapper = styled('dl', {
  display: 'flex',
  margin: 0,
  overflowX: 'auto',
  overflowY: 'hidden',
});
const Segment = styled(
  'div',
  (_, designColors) => ({
    flex: '0 0',
    ':not(:empty) + .SegmentedStats--Segment': {
      // borderLeft: `1px solid ${designColors.borderGrayNormal}`,
      marginLeft: 12,
      paddingLeft: 12,
    },
  }),
  {className: 'SegmentedStats--Segment'},
);
const Label = styled('dt', (_, designColors) => ({
  color: designColors.contentText,
  display: 'block',
  fontSize: 12,
  fontWeight: 400,
  lineHeight: '16px',
  marginBottom: 0,
  whiteSpace: 'nowrap',
}));
const Value = styled('dd', {
  display: 'block',
  fontWeight: 500,
  fontSize: 32,
  lineHeight: '32px',
  margin: 0,
  whiteSpace: 'nowrap',
});

type Stat = {
  label: React.ReactNode;
  value: React.ReactNode;
  // Optional plain-text label exposed to screen readers in place of `label`.
  // Use this when the visible label contains abbreviations that don't read
  // well aloud (e.g. "7d listens" should be announced as "seven day listens").
  labelText?: string;
  // Optional plain-text value exposed to screen readers in place of `value`.
  valueText?: string;
};
type Props = {
  stats: Array<Stat | null | false | undefined>;
};

const SegmentedStats = ({stats}: Props) => {
  return (
    <Wrapper>
      {stats.map(
        (stat, i) =>
          stat && (
            // Each label/value pair is a <div> wrapping a <dt>/<dd> so screen
            // readers announce the segments as discrete term/definition pairs
            // instead of running the text together.
            <Segment key={i}>
              <Label aria-label={stat.labelText}>{stat.label}</Label>
              <Value aria-label={stat.valueText}>{stat.value}</Value>
            </Segment>
          ),
      )}
    </Wrapper>
  );
};

export default SegmentedStats;
